import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import { hideModal } from '../../../actions/modalActions';

function DeletePhotoModal(props) {
  const { onSubmit, onCancel } = props;
  return (
    <div>
      <div className="modal-header">
        <h2 className="modal-title delete-header">Delete this Photo?</h2>
      </div>
      <div className="modal-body">
        <div className="text-right">
          <ButtonV2 variant="tertiary" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2 onClick={onSubmit}>Yes, Delete</ButtonV2>
        </div>
      </div>
    </div>
  );
}

DeletePhotoModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const connectDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: () => {
    dispatch(hideModal());
    if (ownProps.callback) ownProps.callback();
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, connectDispatchToProps)(DeletePhotoModal);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/DeletePhotoModal.jsx